module.exports = __webpack_public_path__ + "img/189.b02ebdc0.jpg";